import api from "@/libs/axios";
import { QueryConfig } from "@/libs/query";
import { infiniteQueryOptions, useInfiniteQuery } from "@tanstack/react-query";
import { apiEnum } from "@/pages/taskpane/shared/types/enums/apiEnum";
import { QUERY_KEY } from "@/pages/taskpane/shared/constants/queryKey";
import { MeetingEntity } from "./entities/meetingEntity";

type PayLoadType = {
    pageSize?: number;
    nextIndex?: number;
    requestId: string;
    organizer: string;
    startDate: string;
    endDate: string;
    timeZoneStandardName: string;
    email: string;
    name: string;
};

const getMeetingColleagues = async (payload: PayLoadType): Promise<{ isLastPage: boolean, nextIndex: number, colleagues: MeetingEntity[] }> => {
    const { data } = await api.post(apiEnum.getMeetingColleagues, payload);
    return {
        isLastPage: data?.data?.isLastPage || false,
        nextIndex: data?.data?.nextIndex || 0,
        colleagues: (data?.data?.colleagues || []).map((item: any) => new MeetingEntity(item)),
    };
};

export const options = (payload: PayLoadType) => infiniteQueryOptions({
    queryKey: [
        QUERY_KEY.GET_MEETING_COLLEAGUES,
        {
            requestId: payload.requestId || '',
            organizer: payload.organizer || '',
            startDate: payload.startDate || '',
            endDate: payload.endDate || '',
            timeZoneStandardName: payload.timeZoneStandardName || '',
            pageSize: payload.pageSize || 10,
            nextIndex: payload.nextIndex || 0,
            email: payload.email || '',
            name: payload.name || '',
        }
    ],
    queryFn: ({ pageParam }) => {
        return getMeetingColleagues({ ...payload, nextIndex: pageParam });
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
        if (lastPage?.isLastPage) {
            return undefined;
        }
        return allPages[allPages.length - 1]?.nextIndex || 0;
    },
})

type GetMeetingColleaguesType = {
    queryConfig?: QueryConfig<typeof options>;
    payload: PayLoadType;
    enabled?: boolean;
};

export const useGetMeetingColleagues = ({ queryConfig, payload, enabled = true }: GetMeetingColleaguesType) => {
    const query = useInfiniteQuery({
        ...options(payload),
        ...queryConfig,
        enabled: enabled,
    });
    return query;
};
